import { API, Card, CheckBox, Date, Explination, Filter, Help, Input, Output, Pagination, SearchModal, Select, Submit, Table, ViewHeader, useGet } from '@enkla-gui'
import React, { useEffect, useRef, useState } from 'react'
import { date as dateHelper, notify } from '@/_helpers'
import { filters, icons } from '@config'
import { useHistory, useLocation, useParams } from 'react-router-dom'

import './create.scss'

import EntityInfo from '@components/entity/EntityInfo'
import { useForm } from 'react-hook-form'

export default function Create() {
  const { register, handleSubmit, control, reset, watch, getValues, setValue } = useForm({
    defaultValues: { lease: { notice_type: 'MONTH' } }
  })
  const location = useLocation();

  const tenantSectionRef = useRef(null)
  const termsSectionRef = useRef(null)
  const [activeSection, setActiveSection] = useState(location.entity ? 'tenant' : 'object')
  const [entity, setEntity] = useState(location.entity || false)
  const [tenant, setTenant] = useState(location.tenant || false)
  const [error, setError] = useState(null)
  const [sending, setSending] = useState(false)
  const [searchModal, setSearchModal] = useState(false)
  const { data: entities, setSorting, loading, setPage, sorting, setFilter } = useGet({ endpoint: `api/entity`, filter: { rentable: true, limit: 7 } })
  const { id, prefillType, prefillId } = useParams()
  const history = useHistory()

  useEffect(() => {
    if (!entity) {
      setActiveSection('object')
      return
    }
    const nextSection = tenant ? termsSectionRef : tenantSectionRef
    setActiveSection(tenant ? 'terms' : 'tenant')
    nextSection.current?.focus({ preventScroll: true })
    nextSection.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }, [entity, tenant])

  useEffect(() => {
    if (!prefillType || !prefillId) return
    if (prefillType === 'entity' && !entity) {
      API.get(`api/entity/${prefillId}`).then(setEntity).catch(() => { })
    }
    if (prefillType === 'tenant' && !tenant) {
      API.get(`api/tenant/${prefillId}`).then(setTenant).catch(() => { })
    }
  }, [prefillType, prefillId])

  useEffect(() => {
    if (!entity) return
    setValue('lease.tax_rate', getValues('tenant.organisation') === 'true' ? entity.type.organisation_tax_rate : entity.type.private_tax_rate)
  }, [watch('tenant.organisation')])
  useEffect(() => {
    setValue('lease.fee', entity.fee || null)
    setValue('address.address', entity.address);
    setValue('address.postal_code', entity.postal_code);
    setValue('address.city', entity.city);
    setValue('address.country', entity.country);

    if (entity?.payment_interval) setValue('lease.payment_interval', entity.payment_interval)
    if (entity?.fee_as_m2) setValue('lease.fee_as_m2', entity.fee_as_m2)

  }, [entity])


  const create = data => {
    setSending(true)
    if (!data.lease.start || data.lease.start === undefined) data.lease.start = dateHelper.today()
    //select returnerar ett textvärde LOL?????
    data.tenant.organisation = data.tenant.organisation === 'true'
    data.lease.entity_id = entity.id
    API.post('api/lease', data)
      .then(async res => {
        notify.toast(`Uthyrning skapad.`)
        history.push(`/lease/${res.lease.id}`)
      })
      .catch(([err, res]) => {
        notify.toast(res.message, 'error')
        setSending(false)
        setError({
          message: res.message,
          data: res.data
        })
      })
  }

  const connect = data => {
    if (!entity) return notify.toast('Du måste välja ett objekt', 'warning')
    setSending(true)
    if (!data.lease.start || data.lease.start === undefined) data.lease.start = dateHelper.today()
    if (data.tenant === undefined) data.tenant = {}
    data.tenant.id = tenant.id
    data.lease.entity_id = entity.id
    API.post('api/lease/connect', data)
      .then(async res => {
        notify.toast(`Uthyrning skapad.`)
        history.push(`/lease/${res.lease.id}`)
        promptUpdateAddress(tenant)
      })
      .catch(([err, res]) => {
        notify.toast(res, 'error')
        setError({
          message: res,
          data: res.data
        })
        setSending(false)
      })
  }

  const promptUpdateAddress = async (tenant) => {
    if (entity.type.id === '0f860f6d-8aca-4bdb-815c-8eb42490d689' && tenant.addresses.length !== 0) {
      await notify.request(
        `Du har hyrt ut en lägenhet till en befintlig hyresgäst, vill du uppdatera hyresgästens primära adress till lägenhets adress?`,
        async () => {
          API.patch('api/address', {
            ...(tenant.billingAddress || tenant.addresses[0]),
            address: entity.address,
            postal_code: entity.postal_code,
            city: entity.city,
            country: entity.country
          })
            .then(res => {
              notify.toast(`Adressen för ${tenant.name} har uppdaterats`)
            })
            .catch(([err, res]) => {
              notify.toast(`Något gick fel: ${res.message}`, 'error')
            })
        },
        'Uppdatera adressuppgifter'
      )
    }
  }

  const handleResponse = response => {
    API.get(`api/tenant/${response.render.id}`)
      .then(tenant => {
        setTenant(tenant)
      })
      .catch(([err, res]) => {
        notify.toast(res.message, 'error')
      })
    setSearchModal(false)
  }
  return (
    <div className='lease-create'>
      <ViewHeader
        title="Uthyrning"
        icon='fa-key'
        subtitle="Skapa"
      />
      <p className='lease-create__intro'>Välj objekt, fyll i hyresgästens uppgifter och ange villkoren. Fält med * är obligatoriska.</p>
      <nav className='lease-create__nav' aria-label='Formulärets delar'>
        <a className={entity ? 'completed' : undefined} aria-label={entity ? 'Objekt, valt' : 'Objekt'} href='#lease-create-object' aria-current={activeSection === 'object' ? 'location' : undefined} onClick={e => { e.preventDefault(); setActiveSection('object'); document.getElementById('lease-create-object').scrollIntoView({ behavior: 'smooth' }) }}><span>{entity ? <i className='fas fa-check' aria-hidden='true' /> : 1}</span> Objekt</a>
        <a className={tenant ? 'completed' : undefined} aria-label={tenant ? 'Hyresgäst, vald' : 'Hyresgäst'} href='#lease-create-tenant' aria-current={activeSection === 'tenant' ? 'location' : undefined} onClick={e => { e.preventDefault(); setActiveSection('tenant'); document.getElementById('lease-create-tenant').scrollIntoView({ behavior: 'smooth' }) }}><span>{tenant ? <i className='fas fa-check' aria-hidden='true' /> : 2}</span> Hyresgäst</a>
        <a href='#lease-create-terms' aria-current={activeSection === 'terms' ? 'location' : undefined} onClick={e => { e.preventDefault(); setActiveSection('terms'); document.getElementById('lease-create-terms').scrollIntoView({ behavior: 'smooth' }) }}><span>3</span> Hyra & villkor</a>
      </nav>
      <section id='lease-create-object' onFocusCapture={() => setActiveSection('object')}>
      <Card
        collapsed={null}
        title='1. Välj objekt'
        icon='fa fa-fw fa-layer-group'
        buttons={{
          header: [
            <button hidden={!entity} onClick={e => {
              e.stopPropagation()
              setEntity(false)
            }} class="btn btn-sm btn-light"><i class="fas fa-hand-pointer" /> Välj ett annat objekt</button>,
          ]
        }}>
        {entity && <>
          <div className='lease-create__selection'>
            <div><span className='lease-create__eyebrow'>{entity.type?.name}</span><h3>{entity.name}</h3><p>{[entity.address, entity.postal_code, entity.city].filter(Boolean).join(', ')}</p></div>
            <span className='lease-create__selected'><i className='fas fa-check' aria-hidden='true' /> Valt objekt</span>
          </div>
          <details className='lease-create__details'><summary>Visa alla objektuppgifter</summary><EntityInfo cardDeclined={true} entity={entity} /></details>
        </>}
        {!entity &&
          <>
            <Filter cardDeclined filters={filters.entity} useFilter={_filter => setFilter({
              ..._filter,
              limit: 7,
              rentable: true
            })} />
            <Table
              loading={loading}
              loadercount={5}
              rows={entities?.data}
              onClick={entity => setEntity(entity)}
              sorting={sorting}
              useSorting={sort => setSorting({ ...sort })}
              functions={{
                getType: type => (
                  <div class='icon-badge'>
                    <i class={`fas fa-fw ${type.icon}`} /> <span>{type.name}</span>{' '}
                  </div>
                ),
                getStatus: entity =>
                  entity.type.rentable ? <span class={`w-100 badge ${entity.rented ? 'bg-success' : 'bg-default'}`}>{entity.rented ? 'Uthyrd' : 'Vakant'}</span> : '',
                getParent: entity => {
                  if (entity.parent) {
                    return (
                      <a onClick={e => e.stopPropagation()} href={`/#!/entity/${entity.parent.id}`}>
                        {entity.parent.name}
                      </a>
                    )
                  }
                  if (entity.company) {
                    return (
                      <a onClick={e => e.stopPropagation()} href={`/#!/company/${entity.company.id}`}>
                        {entity.company.name}
                      </a>
                    )
                  }
                  return ''
                },
                select: entity => setEntity(entity)
              }}
              keys={[`_this>button:select:fa-hand-pointer`, 'name', 'type>function:getType', 'company.name', '_this>function:getParent', '_this>function:getStatus']}
              headers={[
                {
                  value: '',
                  class: 'min'
                },
                {
                  key: 'name',
                  value: 'Namn',
                  sortable: true,
                  class: 'min'
                },
                {
                  key: 'entity_type_id',
                  value: 'Typ',
                  sortable: true,
                  class: 'min'
                },
                {
                  value: 'Företag'
                },
                {
                  value: 'Överordnat objekt'
                },
                {
                  value: 'Status',
                  class: 'min'
                },
              ]}
            />
            <Pagination data={entities} fetch={setPage} />
          </>
        }
      </Card>
      </section>
      <section ref={tenantSectionRef} tabIndex={-1} aria-label='Hyresgäst' id='lease-create-tenant' onFocusCapture={() => setActiveSection('tenant')}>
      <Card
        collapsed={null}
        title='2. Hyresgäst'
        icon='fa fa-fw fa-address-book'
        buttons={{
          header: [
            <button onClick={e => {
              e.stopPropagation()
              setSearchModal(true)
            }} class="btn btn-sm btn-light"><i class="fas fa-search" /> Sök befintlig hyresgäst</button>,
            <button hidden={!tenant} onClick={e => {
              e.stopPropagation()
              setTenant(false)
            }} class="btn btn-sm btn-light"><i class="fas fa-user-plus" /> Skapa ny hyresgäst</button>,
          ]
        }}>
        <p className='lease-create__hint'>{tenant ? 'Den valda hyresgästen kopplas till uthyrningen.' : 'Fyll i en ny hyresgäst nedan, eller sök efter en befintlig hyresgäst.'}</p>
        <input type='hidden' {...register('lease.entity_id')} value={id} />
        {!tenant && (
          <>
            <div class='row mb-3'>
              <Select
                controls={{ register }}
                name='tenant.organisation'
                label='Kundtyp'
                error={error}
                values={[
                  { key: 'Privatkund', value: false },
                  { key: 'Företagskund', value: true }
                ]}
              />
              <Input controls={{ register }} name='tenant.name' options={{ required: true }} label='Namn' error={error} />
            </div>
            <div class='row mb-3'>
              <Input controls={{ register }} name='tenant.identifier' options={{ required: true }} label='Personnummer / Organisationsnummer' error={error} />
              <Input controls={{ register }} name='tenant.phone' options={{ required: true }} label='Telefonnummer' error={error} />
            </div>
            <div class='row mb-3'>
              <Input controls={{ register }} name='tenant.email' options={{ required: false }} label='E-post (kontakt)' error={error} />
              <Input
                controls={{ register }}
                name='tenant.billing_email'
                options={{ required: false }}
                label='E-post (Fakturering)'
                placeholder='Kontakt-e-post används för fakturor om inget annat anges.'
                error={error}
              />
            </div>
            <h3 className='lease-create__group'>Adress</h3>
            <p className='lease-create__hint'>Objektets adress är förifylld. Ändra om hyresgästen har en annan adress.</p>
            <div class='row mb-3'>
              <Input controls={{ register }} name='address.address' options={{ required: true }} label='Adress' error={error} />
              <Input controls={{ register }} name='address.postal_code' options={{ required: true }} label='Postnummer' error={error} />
            </div>
            <div class='row'>
              <Input controls={{ register }} name='address.city' options={{ required: true }} label='Stad' error={error} />
              <Select
                controls={{ register }}
                name='address.country'
                options={{ required: true }}
                label='Land'
                error={error}
                preset="countries"
              />
            </div>
          </>
        )}
        {tenant && (
          <>
            <div class='row mb-3'>
              <Output value={tenant.name} label='Namn' />
              <Output value={tenant.identifier} label='Personnummer / Organisationsnummer' />
            </div>
            <div class='row mb-3'>
              <Output value={tenant.phone} label='Telefonnummer' />
            </div>
            <div class='row mb-3'>
              <Output value={tenant.email} label='E-post' />
              <Output value={tenant.billing_email} label='E-post (Fakturering)' />
            </div>
            <div class='row mb-3'>
              <Output value={tenant.billingAddress?.address || tenant.addresses?.[0]?.address} label='Address' />
              <Output value={tenant.billingAddress?.postal_code || tenant.addresses?.[0]?.postal_code} label='Postnummer' />
            </div>
            <div class='row'>
              <Output value={tenant.billingAddress?.city || tenant.addresses?.[0]?.city} label='Stad' />
              <Output value={tenant.billingAddress?.country || tenant.addresses?.[0]?.country} label='Land' />
            </div>
          </>
        )}
      </Card>
      </section>
      <section ref={termsSectionRef} tabIndex={-1} aria-label='Hyra och villkor' id='lease-create-terms' onFocusCapture={() => setActiveSection('terms')}>
      <Card
        collapsed={null}
        title='3. Hyra & villkor'
        icon='fa fa-fw fa-key'
        buttons={{
        }}>
        <h3 className='lease-create__group'>Hyra och betalning</h3>
        <div class='row mb-3'>
          <Input controls={{ register }} name='lease.reference' options={{ required: false }} label='Avtalsreferens' error={error} />
          <Select
            controls={{ register }}
            name='lease.tax_rate'
            options={{ required: true }}
            label='Momssats(%)'
            error={error}
            values={[
              { key: '0%', value: 0 },
              { key: '6%', value: 6 },
              { key: '12%', value: 12 },
              { key: '25%', value: 25 }
            ]}
          />
        </div>
        <div class='row mb-3'>
          <div class='col'>
            <Input controls={{ register }} name='lease.fee' options={{ required: true }} label={`Hyra (exmoms) per ${{ 'MONTHLY': 'månad', 'QUARTERLY': 'kvartal', 'YEARLY': 'år', 'NONE': 'betalningsintervall' }[watch('lease.payment_interval') || 'NONE']}`} type='number' error={error} />
          </div>
          <div class='col' hidden={!entity.fields?.area}>
            <div class='form-group'>
              <label>Pris per m2 <Explination tip='Vad betyder pris per m2?' /></label>
              <br />
              <CheckBox controls={{ register, getValues, setValue, watch }} name={`lease.fee_as_m2`} options={{ required: false }} label={'Pris per m2'} />
            </div>
          </div>
          <div class='mt-3' hidden={!watch('lease.fee_as_m2')}>
            <Help temporary header={false} type='info'>
              <p>
                Objektet är <b>{entity.fields?.area || 0}m2</b>
              </p>
              <p>
                Hyran blir <b>{watch('lease.fee') * entity.fields?.area} SEK</b>
              </p>
            </Help>
          </div>
        </div>
        <div class='row mb-3'>
          <Select
            controls={{ register }}
            name='lease.payment_interval'
            options={{ required: true }}
            label='Betalningsintervall'
            tip='Angivet intervall hanteras som kalenderperiod'
            error={error}
            values={[
              { key: 'Månadsvis', value: 'MONTHLY' },
              { key: 'Kvartalsvis', value: 'QUARTERLY' },
              { key: 'Årligen', value: 'YEARLY' }
            ]}
          />
        </div>
        <h3 className='lease-create__group'>Avtalstid</h3>
        <div class='row mb-3'>
          <Input controls={{ register }} name='lease.notice_length' options={{ required: true }} label='Uppsägningstid' error={error} />
          <Select
            controls={{ register }}
            name='lease.notice_type'
            options={{ required: true }}
            label='Enhet'
            error={error}
            values={[
              { key: 'Dag(ar)', value: 'DAY' },
              { key: 'Månad(er)', value: 'MONTH' },
              { key: 'År', value: 'YEAR' }
            ]}
          />
        </div>
        <div class='row mb-3'>
          <Date label='Tillträde' controls={{ control }} name='lease.start' error={error} placeholder='Välj ett datum, vid tomt värde anges dagens datum' />
          <Date label='Slutdatum' controls={{ control }} name='lease.stop' error={error} />
        </div>
      </Card>
      </section>
      {error?.message && <div className='lease-create__error' role='alert'>{typeof error.message === 'string' ? error.message : 'Kontrollera uppgifterna och försök igen.'}</div>}
      <div className='lease-create__submit'>
      <p>Kontrollera uppgifterna ovan innan du skapar uthyrningen.</p>
      <Submit disabled={!entity} style="btn-primary" onSubmit={handleSubmit(tenant ? connect : create)} text='Skapa uthyrning' sending={sending} />
      </div>
      <SearchModal
        search={async query =>
          await API.get('api/search', [
            ['query', query],
            ['index', 'tenants']
          ])
        }
        open={searchModal}
        close={() => setSearchModal(false)}
        callback={result => handleResponse(result._source)}
      />
    </div>
  )
}
